export default "__VITE_PUBLIC_ASSET__94579bba__"